import axios from "axios";
import { SuperAdminURL } from "../../../../config/UrlEndPoint";

export const URL = `${SuperAdminURL}log_login`;

export function findLogLogin(queryParams) {
  return axios.post(`${URL}/find`, queryParams);
}
